module.exports = __webpack_public_path__ + "static/sponsorship_img-07-c-76bf78bfd23c48bdf8cb261a4edfbfbe.jpg";